import i18n from '@/translations/lang'

export let embedOptions = [
  {
    text: i18n.t('message.pages.videoEditModal.embedConfiguration.default'),
    value: 'general',
  },
  {
    text: 'Cademi',
    value: 'cademi',
    help: i18n.t('message.embedModal.embedModalTexts.embedCademi'),
  },
  { text: 'CreatorsLand', value: 'creators-land' },
  {
    text: 'Eduzz',
    value: 'eduzz',
    help: i18n.t('message.embedModal.embedModalTexts.embedEduzz'),
  },
  {
    text: 'Elementor',
    value: 'elementor',
    help: i18n.t('message.embedModal.embedModalTexts.embedElementor'),
  },

  { text: 'EngagED ', value: 'engaged' },
  { text: 'Entrega Digital', value: 'entrega-digital' },
  {
    text: 'GreatPages',
    value: 'greatpages',
    help: i18n.t('message.embedModal.embedModalTexts.embedGreatPages'),
  },
  { text: 'Greenn', value: 'greenn' },
  {
    text: 'Hotmart',
    value: 'hotmart',
    help: i18n.t('message.embedModal.embedModalTexts.embedHotmart'),
  },
  { text: 'Kajabi', value: 'kajabi' },
  { text: 'Leadlovers', value: 'leadlovers' },
  {
    text: 'Memberkit',
    value: 'memberkit',
    help: i18n.t('message.embedModal.embedModalTexts.embedMemberkit'),
  },
  { text: 'Membertizze', value: 'membertizze' },
  { text: 'Monetizze', value: 'monetizze' },
  { text: 'Blitzpay', value: 'blitzpay' },
  { text: 'Ticto', value: 'ticto' },
  { text: 'Ensinio', value: 'ensinio' },
  {
    text: 'XGrow',
    value: 'xgrow',
    help: i18n.t('message.embedModal.embedModalTexts.embedXGrow'),
  },
  { text: '123tapronto', value: '123tapronto' },
]
